function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Plugin from '../plugin';
/**
 * @module Modal
 * @since  0.1.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Modal = /*#__PURE__*/function (_Plugin) {
  _inherits(Modal, _Plugin);

  var _super = _createSuper(Modal);

  /**
   * Plugin constructor
   * @param  {Object} options The options object for this plugin
   * @return {this} The newly created plugin instance
   */
  function Modal(options) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, options);
    /** @param {string} */

    _this.style = _this.option('style');
    /** @param {HTMLElement} */

    _this.element = _this.option('element');

    if (!_this.element) {
      _this.element = Bulma.createElement('div', 'modal');
    }
    /** @param {HTMLElement} */


    _this.parent = _this.option('parent');

    if (!_this.parent) {
      if (!_this.element.parentNode) {
        _this.parent = document.body;

        _this.parent.appendChild(_this.element);
      } else {
        _this.parent = _this.element.parentNode;
      }
    } else {
      _this.parent.appendChild(_this.element);
    }
    /** @param {HTMLElement} */


    _this.background = Bulma.findOrCreateElement('.modal-background', _this.element);
    /** @param {HTMLElement} */

    _this.content = _this.style === 'card' ? Bulma.findOrCreateElement('.modal-card', _this.element) : Bulma.findOrCreateElement('.modal-content', _this.element);
    /** @param {boolean} */

    _this.closable = _this.option('closable');
    /** @param {string|null} */

    _this.body = _this.option('body');
    /** @param {string|null} */

    _this.title = _this.option('title');

    if (_this.style === 'card') {
      _this.createCardStructure();
    } else {
      if (!_this.content.innerHTML) {
        _this.content.innerHTML = _this.body;
      }
    }

    if (_this.closable) {
      /** @param {HTMLElement} */
      _this.closeButton = _this.style === 'card' ? Bulma.findOrCreateElement('.delete', _this.header, 'button') : Bulma.findOrCreateElement('.modal-close', _this.element, 'button');
    }
    /** @param {function} */


    _this.onOpen = _this.option('onOpen');
    /** @param {function} */

    _this.onClose = _this.option('onClose');

    if (_this.style === 'card') {
      _this.createButtons();
    }

    _this.setupEvents();

    return _this;
  }
  /**
   * Create the card style structure
   * @returns {void}
   */


  _createClass(Modal, [{
    key: "createCardStructure",
    value: function createCardStructure() {
      /** @param {HTMLElement} */
      this.header = Bulma.findOrCreateElement('.modal-card-head', this.content, 'header');
      /** @param {HTMLElement} */

      this.headerTitle = Bulma.findOrCreateElement('.modal-card-title', this.header, 'p');

      if (!this.headerTitle.innerHTML) {
        this.headerTitle.innerHTML = this.title;
      }
      /** @param {HTMLElement} */


      this.cardBody = Bulma.findOrCreateElement('.modal-card-body', this.content, 'section');

      if (!this.cardBody.innerHTML) {
        this.cardBody.innerHTML = this.body;
      }
      /** @param {HTMLElement} */


      this.footer = Bulma.findOrCreateElement('.modal-card-foot', this.content, 'footer');
    }
    /**
     * Setup the events used by this modal.
     * @returns {void}
     */

  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this2 = this;

      if (this.closable) {
        this.closeButton.addEventListener('click', this.close.bind(this));
        document.addEventListener('keyup', function (event) {
          if (!_this2.element.classList.contains('is-active')) {
            return;
          }

          var key = event.key || event.keyCode;

          if (key === 'Escape' || key === 'Esc' || key === 27) {
            _this2.close();
          }
        });
        this.background.addEventListener('click', this.close.bind(this));
      }
    }
    /**
     * Go through the provided buttons option and create the buttons.
     * @returns {void}
     */

  }, {
    key: "createButtons",
    value: function createButtons() {
      var buttonsConfig = this.option('buttons', []);
      var modal = this;
      Bulma.each(buttonsConfig, function (buttonConfig) {
        var button = Bulma.createElement('button', buttonConfig.classes);
        button.innerHTML = buttonConfig.label;
        button.addEventListener('click', function (event) {
          buttonConfig.onClick(event);
        });
        modal.footer.appendChild(button);
      });
    }
    /**
     * Open the modal
     * @returns {void}
     */

  }, {
    key: "open",
    value: function open() {
      this.element.classList.add('is-active');
      document.documentElement.classList.add('is-clipped');

      if (this.onOpen) {
        this.onOpen(this);
      }
    }
    /**
     * Close the modal
     * @returns {void} 
     */

  }, {
    key: "close",
    value: function close() {
      this.element.classList.remove('is-active');
      document.documentElement.classList.remove('is-clipped');

      if (this.onClose) {
        this.onClose(this);
      }
    }
    /**
     * Destroy this modal, unregistering element references and removing the modal.
     * @returns {void}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.element.remove();
      this.parent = null;
      this.element = null;
      this.background = null;
      this.content = null;

      if (this.style === 'card') {
        this.header = null;
        this.headerTitle = null;
        this.cardBody = null;
        this.footer = null;
      }

      if (this.closable) {
        this.closeButton = null;
      }

      this.options = [];
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options THe options object for the new instance
     * @return {Modal} The newly created instance
     */
    function create(options) {
      return new Modal(options);
    }
    /**
     * Get the root class this plugin is responsible for.
     * This will tell the core to match this plugin to an element with a .modal class.
     * @returns {string} The class this plugin is responsible for.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return 'modal';
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        style: 'card',
        closable: true
      };
    }
  }]);

  return Modal;
}(Plugin);

Bulma.registerPlugin('modal', Modal);
export default Modal;